

export enum PlaceType {
  Area = 'area' ,
  Place = 'place',
  Municipality = 'municipality',
  Province = 'province',
  Country = 'country',
}

export enum PropositionType {
  Free = 0 ,
  Budget = 1,
  Featured = 2,
}
